import { LegalShell } from "./LegalShell";

export default function Terminos() {
  return (
    <LegalShell eyebrow="/ Contrato" title="Términos del servicio" updated="19 de agosto de 2026">
      <h2>1. Identidad del prestador del servicio</h2>
      <p>
        El presente contrato regula la prestación del servicio de plataforma tecnológica denominada
        <strong> CHALANN</strong>, ofrecida por <strong>MARKETING DE INTELIGENCIA ARTIFICIAL S. de R.L. de C.V.</strong>
        (en adelante, &ldquo;El Prestador&rdquo;), con domicilio fiscal en Av. Américas 1545, Colonia Providencia,
        Guadalajara, Jalisco, México, teléfono <a href="tel:+523342802102">33 4280 2102</a>, representada legalmente por
        el <strong>Sr. Ricardo Zermeño Mejía</strong>.
      </p>

      <h2>2. Objeto</h2>
      <p>
        CHALANN es un software como servicio (SaaS) que permite al Usuario administrar el punto de venta
        de su negocio mediante comandos de voz, escáner de código de barras, inventario dinámico, cuentas
        de fiado, reportes diarios, recibos digitales por QR y demás funcionalidades ofrecidas en la
        plataforma. El Prestador otorga al Usuario una licencia limitada, no exclusiva, intransferible y
        revocable para acceder y usar la plataforma conforme a estos Términos.
      </p>

      <h2>3. Registro y cuenta del usuario</h2>
      <p>
        Para utilizar el servicio, el Usuario debe registrar su negocio proporcionando información veraz
        y actualizada. El Usuario es el único responsable de la información capturada, del uso de las
        credenciales de acceso (PIN de dueño y empleados) y de las operaciones que se realicen desde su
        cuenta.
      </p>

      <h2>4. Planes disponibles</h2>
      <p>
        El Prestador ofrece dos planes: <strong>CHALANITO</strong>, que incluye comandos de voz con
        inteligencia artificial, y <strong>ONE PAY</strong>, un punto de venta operado con escáner de código de
        barras y buscador, <strong>sin funciones de inteligencia artificial ni comandos de voz</strong>. El servicio no
        cuenta con periodo de prueba gratuita; se activa una vez confirmado el pago del plan elegido. El
        Usuario puede cambiar de plan en cualquier momento; el nuevo plan aplica a partir del pago correspondiente.
      </p>

      <h2>5. Precio, forma de pago y renovación</h2>
      <p>
        El plan CHALANITO tiene un precio de <strong>$20 USD (veinte dólares americanos)</strong> mensuales por
        negocio y el plan ONE PAY de <strong>$25 USD (veinticinco dólares americanos)</strong> por pago único anual.
        El pago puede realizarse con tarjeta de crédito o débito a través de Stripe, o mediante transferencia
        bancaria SPEI en pesos mexicanos al tipo de cambio publicado dentro de la plataforma al momento del pago.
        Confirmado el pago, el servicio se activa por 30 días naturales (CHALANITO) o 365 días naturales (ONE PAY),
        y así sucesivamente mientras el Usuario continúe pagando. El Prestador no cobra comisiones por venta ni
        cargos por dispositivo adicional.
      </p>

      <h2>6. Cap de uso justo</h2>
      <p>
        El plan Chalanito incluye hasta <strong>300 comandos de inteligencia artificial por día</strong>.
        Al superar dicho límite, la plataforma sigue operando en modo local sin costo adicional; el
        contador se reinicia automáticamente al día siguiente.
      </p>

      <h2>7. Suspensión y terminación</h2>
      <p>
        Si al concluir el periodo pagado el Usuario no realiza el siguiente pago, la cuenta pasará a
        estado <em>vencida</em> y las funcionalidades quedarán limitadas hasta que se regularice.
        El Prestador se reserva el derecho de suspender o cancelar cuentas que incumplan estos Términos,
        realicen usos fraudulentos, intenten vulnerar la seguridad de la plataforma o alteren la
        experiencia de otros usuarios. El Usuario puede cancelar en cualquier momento; los pagos ya
        realizados no son reembolsables por periodos parciales.
      </p>

      <h2>8. Propiedad intelectual</h2>
      <p>
        La marca <strong>CHALANN</strong>, el software, sus algoritmos de reconocimiento de voz y
        cualquier contenido de la plataforma son propiedad exclusiva de El Prestador o de sus
        licenciantes. El Usuario conserva la propiedad de los datos que captura (inventario, ventas,
        clientes) y puede solicitar su exportación en cualquier momento.
      </p>

      <h2>9. Limitación de responsabilidad</h2>
      <p>
        El servicio se ofrece &ldquo;tal cual&rdquo;. El Prestador realiza sus mejores esfuerzos para mantener la
        plataforma disponible y sin errores, pero no garantiza operación ininterrumpida ni infalibilidad
        del reconocimiento de voz. El Prestador no será responsable por pérdidas de utilidad, lucro
        cesante o daños indirectos derivados del uso o la imposibilidad de uso del servicio.
      </p>

      <h2>10. Modificaciones</h2>
      <p>
        El Prestador podrá modificar los presentes Términos publicando la nueva versión en la
        plataforma. El uso continuo del servicio después de una modificación implica la aceptación de
        la misma.
      </p>

      <h2>11. Jurisdicción</h2>
      <p>
        Para la interpretación y cumplimiento del presente contrato, las partes se someten expresamente
        a la jurisdicción de los tribunales competentes de la Ciudad de Guadalajara, Jalisco, México,
        renunciando a cualquier otro fuero que pudiera corresponderles por razón de su domicilio
        presente o futuro.
      </p>

      <h2>12. Aceptación</h2>
      <p>
        Al registrar un negocio y utilizar la plataforma CHALANN, el Usuario declara haber leído,
        entendido y aceptado en su totalidad los presentes Términos del Servicio, así como el Aviso de
        Privacidad publicado por El Prestador.
      </p>

      <p className="mt-8 not-prose text-sm text-neutral-600">
        Representante legal: <strong>Ricardo Zermeño Mejía</strong>.
      </p>
    </LegalShell>
  );
}
